import { FC, memo, useContext, useEffect } from 'react';

import day from 'dayjs';

import { useForceUpdate } from 'hooks';
import { LocalizationContext } from 'localization';

interface ITimerProps {
  tariffsDuration: number;
  shouldIncrement?: boolean;
}

const getFormattedEndTime = (tariffsDuration: number): string => {
  return day().add(tariffsDuration, 'seconds').format('D MMMM, HH:mm:ss');
};

export const Timer: FC<ITimerProps> = memo(
  ({ tariffsDuration, shouldIncrement }) => {
    const { t } = useContext(LocalizationContext);
    const forceUpdate = useForceUpdate();

    useEffect(() => {
      if (!shouldIncrement) {
        return;
      }

      const id = setInterval(forceUpdate, 1000);
      return () => {
        clearInterval(id);
      };
    }, [forceUpdate, tariffsDuration, t]);

    return (
      <span>
        {tariffsDuration ? getFormattedEndTime(tariffsDuration) : '—'}
      </span>
    );
  }
);
